import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";

import { Link } from "react-router-dom";
export default function ConstructionControlView() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
     
 <Header/>
      <main className="prs">
        {/* ===== HERO ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Contrôle Technique de Construction</h1>
            <p>
              VERATRAC SAFETY intervient dans le domaine du contrôle technique
              des constructions afin d’assurer la qualité, la sécurité et la
              conformité réglementaire des ouvrages neufs ou en rénovation.
              Nos ingénieurs accompagnent les maîtres d’ouvrage et bureaux
              d’études tout au long du projet.
            </p>

            <div className="prs-hero__bullets">
              <span>🏗️ Suivi de chantiers & conformité</span>
              <span>📏 Vérification des structures</span>
              <span>⚙️ Assistance technique & audit</span>
            </div>

            <a href="#contact" className="btn-primary">
              Demander un devis
            </a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/construction/5.jpg" alt="Contrôle de structure béton" /></div>
              <div><img src="/images/construction/2.jpeg" alt="Chantier industriel" /></div>
              <div><img src="/images/construction/3.jpeg" alt="Inspection sur site" /></div>
              <div><img src="/images/construction/4.jpeg" alt="Charpente métallique" /></div>
              <div><img src="/images/construction/1.jpeg" alt="Ouvrage technique" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== SECTION DÉTAILS ===== */}
        <section className="prs-reglement prs-simple">
          <h2>Nos missions de contrôle</h2>
          <p>
            Nos ingénieurs effectuent le <strong>contrôle réglementaire</strong>
            et le <strong>suivi technique</strong> de toutes les étapes d’un
            projet de construction, depuis la conception jusqu’à la réception
            des travaux.  
            L’objectif : prévenir les risques structurels, électriques ou de
            sécurité incendie, et garantir la conformité avec les normes
            marocaines et internationales en vigueur.
          </p>

          <h3>Domaines d’intervention</h3>
          <ul>
            <li>Contrôle technique des bâtiments et ouvrages d’art.</li>
            <li>Inspection de structures métalliques, charpentes et ponts roulants.</li>
            <li>Contrôle des fondations, dallages et béton armé.</li>
            <li>Vérification des installations électriques et de levage sur chantier.</li>
            <li>Assistance à la conformité parasismique et sécurité incendie.</li>
          </ul>

          <h3>Phases du contrôle technique</h3>
          <ul>
            <li><strong>Phase 1 :</strong> Analyse des études d’exécution et identification des points critiques.</li>
            <li><strong>Phase 2 :</strong> Visites de chantier et inspections des lots techniques (gros œuvre, charpente, réseaux).</li>
            <li><strong>Phase 3 :</strong> Essais, mesures et vérifications de conformité (métrologie, étanchéité, résistance).</li>
            <li><strong>Phase 4 :</strong> Rapport final avec avis technique, remarques et plan d’action correctif.</li>
          </ul>

          <h3>Référentiels et normes applicables</h3>
          <p>
            Tous les contrôles sont réalisés conformément aux prescriptions du
            <strong> Règlement Général de Construction au Maroc (RGC)</strong>,
            aux <strong>Normes NM / ISO</strong>, et aux directives
            <strong> Eurocodes </strong> pour le dimensionnement et la sécurité
            structurale.
          </p>

          <h3>Accompagnement et expertise</h3>
          <p>
            VERATRAC SAFETY met à disposition des équipes expérimentées dans la
            détection de non-conformités, l’évaluation des risques techniques et
            la mise en œuvre de solutions correctives sur site.  
            Nous intervenons auprès des promoteurs, collectivités, bureaux
            d’études, industriels et organismes publics.
          </p>

          <h3>Livrables et suivi</h3>
          <ul>
            <li>Rapport technique de contrôle avec photos et conclusions détaillées.</li>
            <li>Attestation de conformité aux normes et règlements.</li>
            <li>Suivi des actions correctives jusqu’à levée des réserves.</li>
          </ul>

          <h3>Nos moyens humains</h3>
          <p>
            Une équipe pluridisciplinaire composée d’<strong>ingénieurs civils, électriciens,
            mécaniciens et experts HSE</strong>
          </p>

          <div className="prs-btns">
            <Link to="/#contact" className="btn-primary">faire une consultation</Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
